<template>
  <div>
    <div class="nav-vertical">
      <ul class="nav nav-tabs nav-left" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link active"
            v-bind:href="'#t2' + rowData.docfis_id + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Partes Envolvidas
              <i class="fa fa-building"></i>
            </span>
          </a>
        </li>
      </ul>

      <div class="tab-content">
        <div
          role="tabpanel"
          class="tab-pane fade fade in active show"
          v-bind:id="'t2' + rowData.docfis_id + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 10%"></th>
                <th style="width: 20%">CNPJ/CPF</th>
                <th style="width: 20%">Nome</th>
                <th style="width: 20%">Endereço</th>
                <th style="width: 20%">Municipio</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span class="badge badge-primary">Emitente</span>
                </td>
                <td>
                  <span v-if="rowData.doc_fiscal_partes_env.emi_cnpj != null">{{
                    ajustaMascara(rowData.doc_fiscal_partes_env.emi_cnpj)
                  }}</span>
                  <span v-if="rowData.doc_fiscal_partes_env.emi_cpf != null">{{
                    ajustaMascara(rowData.doc_fiscal_partes_env.emi_cpf)
                  }}</span>
                </td>
                <td>
                  {{ rowData.doc_fiscal_partes_env.emi_nome }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_partes_env.emi_endereco }}
                </td>
                <td>
                  <span
                    v-if="rowData.doc_fiscal_partes_env.emi_municipio != null"
                    >{{
                      rowData.doc_fiscal_partes_env.emi_municipio.nome
                    }}</span
                  >
                </td>
              </tr>
            </tbody>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span class="badge badge-warning">Destinatário</span>
                </td>
                <td>
                  <span v-if="rowData.doc_fiscal_partes_env.des_cnpj != null">{{
                    ajustaMascara(rowData.doc_fiscal_partes_env.des_cnpj)
                  }}</span>
                  <span v-if="rowData.doc_fiscal_partes_env.des_cpf != null">{{
                    ajustaMascara(rowData.doc_fiscal_partes_env.des_cpf)
                  }}</span>
                </td>
                <td>
                  {{ rowData.doc_fiscal_partes_env.des_nome }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_partes_env.des_endereco }}
                </td>
                <td>
                 <span
                    v-if="rowData.doc_fiscal_partes_env.des_municipio != null"
                    >{{
                      rowData.doc_fiscal_partes_env.des_municipio.nome
                    }}</span
                  >
                </td>
              </tr>
            </tbody>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span class="badge badge-info">Redespacho</span>
                </td>
                <td>
                  <span v-if="rowData.doc_fiscal_partes_env.red_cnpj != null">{{
                    ajustaMascara(rowData.doc_fiscal_partes_env.red_cnpj)
                  }}</span>
                  <span v-if="rowData.doc_fiscal_partes_env.red_cpf != null">{{
                    ajustaMascara(rowData.doc_fiscal_partes_env.red_cpf)
                  }}</span>
                </td>
                <td>
                  <span v-if="rowData.doc_fiscal_partes_env.red_nome != null">{{
                    rowData.doc_fiscal_partes_env.red_nome
                  }}</span>
                </td>
                <td>
                  {{ rowData.doc_fiscal_partes_env.red_endereco }}
                </td>
                <td>
                  <span
                    v-if="rowData.doc_fiscal_partes_env.red_municipio != null"
                    >{{
                      rowData.doc_fiscal_partes_env.red_municipio.nome
                    }}</span
                  >
                </td>
              </tr>
            </tbody>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span class="badge badge-secondary">Tomador</span>
                </td>
                <td>
                  <span v-if="rowData.doc_fiscal_partes_env.tom_cnpj != null">{{
                    ajustaMascara(rowData.doc_fiscal_partes_env.tom_cnpj)
                  }}</span>
                  <span v-if="rowData.doc_fiscal_partes_env.tom_cpf != null">{{
                    ajustaMascara(rowData.doc_fiscal_partes_env.tom_cpf)
                  }}</span>
                </td>
                <td>
                  <span v-if="rowData.doc_fiscal_partes_env.tom_nome != null">{{
                    rowData.doc_fiscal_partes_env.tom_nome
                  }}</span>
                </td>
                <td>
                  {{ rowData.doc_fiscal_partes_env.tom_endereco }}
                </td>
                <td>
                  <span
                    v-if="rowData.doc_fiscal_partes_env.tom_municipio != null"
                    >{{
                      rowData.doc_fiscal_partes_env.tom_municipio.nome
                    }}</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
      </div>
      <!--.tab-content-->
    </div>
  </div>
</template>

  <script>
import moment from "moment";

export default {
  data() {
    return {
      helpForm: new Form({ recordCollection: [], status: "" }),
      cnpj_formatado: ""
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  methods: {
    onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      var cnpj_formatado;
      var pad = "00000000";
      var cnpj_base =
        pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
      var pad = "0000";
      var cnpj_filial =
        pad.substring(0, pad.length - cnpj_filial.toString().length) +
        cnpj_filial;
      var pad = "00";
      var cnpj_digito =
        pad.substring(0, pad.length - cnpj_digito.toString().length) +
        cnpj_digito;

      return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
    },
    DateFormat: function(date) {
      if (date != null) {
        return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
      }
      return "";
    },
    onActivateDesactivate(action, data, tipo) {
      // Tipo = true = Checkbox
      this.helpForm.status = action;
      if (tipo) {
        this.helpForm.recordCollection = [];
        this.helpForm.recordCollection.push(data.unidoc_id);
      } else {
        this.helpForm.recordCollection = [];
        this.$refs.vuetable.selectedTo.forEach(obj => {
          this.helpForm.recordCollection.push(obj);
        });
      }
      this.$refs.vinculardocumentounidadeform.onActivateDesactivate(
        this.helpForm
      );
    },
    ajustaMascara(data) {
      if (data != null) {
        if (data.length == 11) {
          //cpf
          return data.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
        }
        if (data.length == 14) {
          //cnpj
          return data.replace(
            /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
            "$1.$2.$3/$4-$5"
          );
        }
      }
    }
  }
};
</script>
